import { render, staticRenderFns } from "./TireRecommendationsBanner.vue?vue&type=template&id=c285019a"
import script from "./TireRecommendationsBanner.vue?vue&type=script&lang=ts"
export * from "./TireRecommendationsBanner.vue?vue&type=script&lang=ts"
import style0 from "./TireRecommendationsBanner.vue?vue&type=style&index=0&id=c285019a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports